module.exports = __webpack_public_path__ + "static/media/sell.704c3b16.svg";